import type { ReactNode } from 'react'
import { SalientHeader } from './SalientHeader'
import { SalientFooter } from './SalientFooter'

interface SalientPageLayoutProps {
  children: ReactNode
  showHeader?: boolean
  showFooter?: boolean
}

export function SalientPageLayout({ 
  children, 
  showHeader = true, 
  showFooter = true 
}: SalientPageLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      {showHeader && <SalientHeader />}
      <main className="flex-1">
        {children}
      </main>
      {showFooter && <SalientFooter />}
    </div>
  )
} 